/* This is the EMIS private pre school fee components */

<template>
  <v-container>
    <v-row>
      <span v-html="title"></span>
    </v-row>
    <v-row>
      <table
        style="height: 61px; width: 700px"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr style="height: 25px">
            <td
              style="
                height: 25px;
                width: 280px;
                text-align: center;
                vertical-align: middle;
              "
            >
              រូបិយវត្ថុ
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              កម្រិតទាប
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              កម្រិតមធ្យម
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              កម្រិតខ្ពស់
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ថ្នាក់ចម្រុះ
            </td>
          </tr>
          <tr style="height: 25px">
            <td style="height: 25px; width: 280px;">
              ជាប្រាក់ដុល្លារក្នុងមួយនាក់
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput v-model="data[0].dt[0]" style="width: 70px" />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput v-model="data[0].dt[1]" style="width: 70px" />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput v-model="data[0].dt[2]" style="width: 70px" />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput v-model="data[0].dt[3]" style="width: 70px" />
            </td>
          </tr>
        </tbody>
      </table>
    </v-row>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
export default {
  props: ["data", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
</style>